module.exports = __webpack_public_path__ + "assets/img/back_video.c2ad1ab7.png";